import { IMessagesState, IPagination } from '../states';

export const initialMessagesState: IMessagesState = {
  value: [],
  isFetchingMessages: true,
  pagination: {} as IPagination,
};
